var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0215 3.52925C14.2819 3.7896 14.2819 4.21171 14.0215 4.47206L6.6882 11.8054C6.42785 12.0657 6.00574 12.0657 5.74539 11.8054L2.41206 8.47206C2.15171 8.21171 2.15171 7.7896 2.41206 7.52925C2.67241 7.2689 3.09452 7.2689 3.35487 7.52925L6.2168 10.3912L13.0787 3.52925C13.3391 3.2689 13.7612 3.2689 14.0215 3.52925Z",
    fill: "#0E0C15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck02);
export default __webpack_public_path__ + "static/media/check-02.792a92d6013520b7971ec390b7c4779f.svg";
export { ForwardRef as ReactComponent };